const MuiDialog = () => ({
  defaultProps: {
    container: () => document.getElementById("root") ?? document.body,
  },
});

export default MuiDialog;
